module.exports = __webpack_public_path__ + "img/user-logo.0f2cd599.svg";